import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexCompanies from "./companies/IndexCompanies";
import IndexLocations from './locations/IndexLocations';
import IndexAreas from './areas/IndexAreas';
import IndexBranches from './branches/IndexBranches';
import IndexDepartments from './departments/IndexDepartments';
import IndexGrades from './grades/IndexGrades';
import IndexDesignations from './designations/IndexDesignations';
import IndexJobTitles from './jobTitles/IndexJobTitles';
import Indexgroups from './groups/IndexGroups';
import IndexOrgChart from "./orgchart/IndexOrgChart";
import { guardElement } from "@comps/components";


const OrgnizationModules = () => {

  return (
    <Routes>
      <Route path="companies" element={ guardElement(<IndexCompanies modkey="companies"/>, "companies") } />
      <Route path="locations" element={ guardElement(<IndexLocations modkey="locations"/>, "locations") } />
      <Route path="areas" element={ guardElement(<IndexAreas modkey="areas"/>, "areas") } />
      <Route path="branches" element={ guardElement(<IndexBranches modkey="branches"/>, "branches") } />
      <Route path="departments" element={ guardElement(<IndexDepartments modkey="departments"/>, "departments") } />
      <Route path="grades" element={ guardElement(<IndexGrades modkey="grades"/>, "grades") } />
      <Route path="designations" element={ guardElement(<IndexDesignations modkey="designations"/>, "designations") } />
      <Route path="jobtitles" element={ guardElement(<IndexJobTitles modkey="jobTitles"/>, "jobTitles") } />
      <Route path="groups" element={ guardElement(<Indexgroups modkey="groups"/>, "groups") } />
      <Route path="organization-structure" element={ guardElement(<IndexOrgChart modkey="organizationStructure" />, "organizationStructure") } />

    </Routes>
  );
}

export default OrgnizationModules;
